import { Api } from '@services/api';

type IntegrationSettings = {
  should_sync: boolean;
  skip_user_invite: boolean;
};

type IntegrationSettingsResponse = {
  data: IntegrationSettings;
};

export const getIntegrationSettings = async (
  organisationId: string
): Promise<IntegrationSettingsResponse> => {
  return Api.get<IntegrationSettingsResponse>(
    `/v1/organisations/${organisationId}/integration`
  );
};
export const updateIntegrationSettings = async (
  organisationId: string,
  payload: IntegrationSettings
): Promise<IntegrationSettingsResponse> => {
  return Api.put<IntegrationSettingsResponse>(
    `/v1/organisations/${organisationId}/integration`,
    payload
  );
};
